import { render } from "./OcrReportPagePreview.vue?vue&type=template&id=665623d7"
import script from "./OcrReportPagePreview.vue?vue&type=script&lang=js"
export * from "./OcrReportPagePreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__